module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./QualificationView.js"));
	}, "QualificationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QualificationView!./src/pages/Shop/Product/Qualification/QualificationView.js
// module id = 1773
// module chunks = 367